module.exports = __webpack_public_path__ + "img/soft-bg-2-dark.bb53bfc7.png";